import Parse from 'parse';

export type ParseObjectType = {
  new (attributes?: any): Parse.Object<any>;
};

export const Account = Parse.Object.extend('Account') as ParseObjectType;
Parse.Object.registerSubclass('Account', Account);

export const Client = Parse.Object.extend('Client') as ParseObjectType;
Parse.Object.registerSubclass('Client', Client);

export const Photo = Parse.Object.extend('Photo') as ParseObjectType;
Parse.Object.registerSubclass('Photo', Photo);

export const Item = Parse.Object.extend('Item') as ParseObjectType;
Parse.Object.registerSubclass('Item', Item);

export const Invoice = Parse.Object.extend('Invoice') as ParseObjectType;
Parse.Object.registerSubclass('Invoice', Invoice);

export const Setting = Parse.Object.extend('Setting') as ParseObjectType;
Parse.Object.registerSubclass('Setting', Setting);

export const Msg = Parse.Object.extend('Msg') as ParseObjectType;
Parse.Object.registerSubclass('Msg', Msg);

export const MsgEvent = Parse.Object.extend('MsgEvent') as ParseObjectType;
Parse.Object.registerSubclass('MsgEvent', MsgEvent);

export const Expense = Parse.Object.extend('Expense') as ParseObjectType;
Parse.Object.registerSubclass('Expense', Expense);
